/* eslint-disable no-console */
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';

/**
 * Método para aplicação das configurações no rótulo da feição
 *
 * @param {object} settings
 */
export const applyLabelSetting = (settings) => {
  let feature = settings.feature;  
  
  if (feature.pm.textArea) {
    feature.pm.getElement().style.display = "none";
    // Define largura máxima em 450px considerando a largura do caractere 'm',
    // o suficiente para 50 caracteres que é o limite para o tipo de camada 'texto'
    if (feature.options.opacity !== 0 && settings.columnName !== undefined) {
      settings.opacity === 0 
        ? feature.pm.getElement().style.display = "none"
        : feature.pm.getElement().style.display = "block"      
      feature.pm.getElement().style.width = '535px';
      feature.pm.getElement().style.height = '610px';
      feature.pm.getElement().value = feature.feature.properties[settings.columnName];
    }    
  } else {
    let fontWeight = settings.isFontBold ? 'bold' : 'normal';
    feature.unbindTooltip();
    if (feature.options.opacity !== 0 && settings.columnName !== undefined) {
      feature.bindTooltip(
        `<div style=' color:${settings.fontColor || '#000000'}; font-size:${
          settings.fontSize || 14
        }px; font-weight: ${fontWeight}; text-shadow: -1px 0 0 ${
          settings.outlineColor || '#e0e0e0'
        }, -1px -1px 0 ${settings.outlineColor || '#e0e0e0'}, 0 -1px 0 ${
          settings.outlineColor || '#e0e0e0'
        }, 1px -1px 0 ${settings.outlineColor || '#e0e0e0'}, 1px 0 0 ${
          settings.outlineColor || '#e0e0e0'
        }, 1px 1px 0 ${settings.outlineColor || '#e0e0e0'}, 0 1px 0 ${
          settings.outlineColor || '#e0e0e0'
        }, -1px 1px 0 ${
          settings.outlineColor || '#e0e0e0'
        };'>${feature.feature.properties[settings.columnName].toLocaleString(
          'pt-BR'
        )}</div>`,
        {
          direction: 'center',
          opacity: 1,
          permanent: true,
          interactive: true,
          className: 'leaflet-transparent-tooltip',
          offset: [0, -8],
          ...settings,
        }
      );
    }
  }
  
  // feature.unbindTooltip();
  // feature.bindPopup(`${feature.feature.properties[settings.columnName]}`, {
  //   autoPan: false,
  //   autoClose: false,
  //   closeOnClick: false,
  // }).openPopup();
};

/**
 * Modifica final do nome das propriedades da feição de uma camada
 * se limitando até 10 caractes para garantir combatibilidade com a
 * tabela de atributos e com as aplicações GIS desktop
 *
 * @param {Array} arrProperties
 * @param {String} endLabel
 */
export const changeEndLabelProperties = (arrProperties, endLabel = '_1') => {
  let arrPropertiesLabel = [];
  arrPropertiesLabel = Object.getOwnPropertyNames(arrProperties);
  let arrPropertiesChanged = arrPropertiesLabel.map((p) => {    
    return endLabel 
            ? p.substring(0, 8) + endLabel
            : p.substring(0, 10);
  });
  return arrPropertiesChanged;
};

/**
 * Obtém objeto com propriedades modificadas da feição
 *
 * @param {Object} featureProperties
 * @param {String} endLabel
 */
export const getPropertiesChangedOldFeature = (featureProperties, endLabel) => {
  let arrPropertiesChanged = changeEndLabelProperties(
    featureProperties,
    endLabel
  );
  // Obtém os valores das propriedades da feição
  let arrValuesProperties = Object.values(featureProperties);
  // Retorna associação propriedades modificadas da feição com seus respectivos valores
  return arrPropertiesChanged.reduce((accumulator, element, index) => {
    return { ...accumulator, [element]: arrValuesProperties[index] };
  }, {});
};

/**
 * Estrutura feições no padrão necessário da biblioteca turf
 */
export const getTurfedFeatures = (
  layerToGetFeatures,
  includeSelectedFeatures = true
) => {
  let arrFeaturesToIntersect = [];
  // Verifica se há feições selecionadas através da tabela de atributos
  if (
    includeSelectedFeatures &&
    layerToGetFeatures.selectedFeatures.length > 0
  ) {
    //obtém feição selecionada
    let includeFeaturesSelected = layerToGetFeatures.selectedFeatures;
    // Foi necessário recriar o objeto para que
    // não sobrescrevesse as propriedades do objeto inicial
    includeFeaturesSelected.forEach((f) => {
      arrFeaturesToIntersect.push({
        geometry: f.geometry,
        properties: {
          ...f.properties,
        },
        type: f.type,
      });
    });
  } else {
    // Obtém e reestrutura todas as feições da camada
    layerToGetFeatures.leafletLayer.eachLayer((f) => {
      // Foi necessário recriar o objeto para que
      // não sobrescrevesse as propriedades do objeto inicial
      arrFeaturesToIntersect.push(simplifyAttributes(f));
    });
  }
  return arrFeaturesToIntersect;
};

export const getObjectRecreated = (featuresSelected) => {
  let arrFeaturesToExport = {};
  // Foi necessário recriar o objeto para que
  // não sobrescrevesse as propriedades do objeto inicial
  arrFeaturesToExport = {
    geometry: featuresSelected.geometry,
    properties: {
      ...featuresSelected.properties,
    },
    type: featuresSelected.type,
  };

  return arrFeaturesToExport;
};
/**
 * Simplifica os atributos da feição
 */
export const simplifyAttributes = (feature) => {
  let simpleFeature = {};
  simpleFeature = {
    geometry: feature.feature.geometry,
    properties: {
      ...feature.feature.properties,
    },
    type: feature.feature.type,
  };
  return simpleFeature;
};

/**
 * Obtém feições não intersectadas da primeira camada informada com a segunda
 * OBS.: Obtém APENAS as feições NÃO intersectadas da primeira camada
 */
export const getNonIntersectedFeatures = (arrFeaturesOne, arrFeaturesTwo) => {
  let arrNonIntersectedFeatures = [];
  let hasIntersected = false;

  arrFeaturesOne.forEach((f, i) => {
    for (
      let iNextFeature = 0;
      iNextFeature <= arrFeaturesTwo.length - 1;
      iNextFeature++
    ) {
      let intersectedFeature = turf.intersect(f, arrFeaturesTwo[iNextFeature]);

      if (intersectedFeature) {
        hasIntersected = true;
        break;
      }
    }

    if (!hasIntersected) {
      arrNonIntersectedFeatures.push(f);
    }
    hasIntersected = false;
  });

  return arrNonIntersectedFeatures;
};

/**
 * Obtém array de feições estruturadas para a biblioteca turf
 */
export const getFeaturesTurf = (layerToGetFeatures) => {
  let arrFeaturesToIntersect = [];
  // Verifica se há feições selecionadas através da tabela de atributos da camada
  if (layerToGetFeatures.selectedFeatures.length > 0) {            
    arrFeaturesToIntersect = layerToGetFeatures.selectedFeatures;
  } else {
    // Obtém e reestrutura todas as feições da camada
    layerToGetFeatures.leafletLayer.eachLayer((f) => {        
      // Foi necessário recriar o objeto para que
      // não sobrescrevesse as propriedades do objeto inicial
      arrFeaturesToIntersect.push({
        geometry: f.feature.geometry,
        properties: {
          ...f.feature.properties
        },
        type: f.feature.type,
      });
    });       
  }   
  return arrFeaturesToIntersect;
};
